import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const skeletonClasses = tv({
  base: [
    "bg-gray-300",
    // "transition-all",
    // "duration-150",
    "size-24",
  ],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-md"],
    },
    hasChild: {
      true: ["flex", "items-center", "justify-center", "text-gray-400"],
    },
    isAnimate: {
      true: ["animate-pulse"],
      false: [],
    },
  },
  defaultVariants: {
    isAnimate: true,
  },
});

export type SkeletonVariants = VariantProps<typeof skeletonClasses>;
